import { EntDirectoryInfoName } from "../../../models/directoryInfoName";
import { EntInitialFilterName } from "../../../models/filters/initialFilterName";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { agroApi } from "../api";
import { Paths } from "../../../paths";

export const typeObjectApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getTypeObjectList: builder.query<ResponseDataGet<EntDirectoryInfoName>, EntInitialFilterName>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.typeobject }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getTypeObjectById: builder.query<ResponseDataGet<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.typeobject }/${ id }`,
		method: 'GET',
	  }),
	}),

	addTypeObject: builder.mutation<ResponseDataGet<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body) => ({
		url: `${ Paths.handbooks.typeobject }`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editTypeObject: builder.mutation<ResponseDataGet<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body) => ({
		url: `${ Paths.handbooks.typeobject }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteTypeObject: builder.mutation<ResponseDataGet<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.typeobject }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddTypeObjectMutation,
  useDeleteTypeObjectMutation,
  useEditTypeObjectMutation,
  useLazyGetTypeObjectListQuery
} = typeObjectApi;
